import { render, staticRenderFns } from "./ShipMarineTrafficDashboardWidget.vue?vue&type=template&id=6c4ea805&scoped=true"
import script from "./ShipMarineTrafficDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipMarineTrafficDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipMarineTrafficDashboardWidget.vue?vue&type=style&index=0&id=6c4ea805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4ea805",
  null
  
)

export default component.exports